import Vue from 'vue';
import Router from 'vue-router';
import store from './store';
import fb from './firebaseConfig';
import { IS_AUTHENTICATED } from './store/constants';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      redirect: '/'
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import(/* webpackChunkName: "Login" */ './views/Login.vue')
    },
    {
      path: '/signup',
      name: 'Signup',
      component: () => import(/* webpackChunkName: "Signup" */ './views/Signup.vue')
    },
    {
      path: '/',
      name: 'Home',
      component: () => import(/* webpackChunkName: "Home" */ './views/Home.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/settings',
      name: 'Settings',
      component: () => import(/* webpackChunkName: "Settings" */ './views/Settings.vue'),
      meta: {
        requiresAuth: true
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth);
  const isAuth = store.state.auth[IS_AUTHENTICATED];
  if (requiresAuth && !isAuth) {
    next('/login');
  } else if (requiresAuth && isAuth) {
    next();
  } else if (!requiresAuth && isAuth) {
    next('/');
  } else {
    next();
  }
});

export default router;
